// stageconfig.js will be copied from QA folder during build process
var stageConfig = require("./stageconfig.json");

stageConfig.EXTENSIONFRAME_BASELOCATION = stageConfig.EXTENSIONFRAME_BASEURL;

if (stageConfig.EXTENSIONFRAME_BASEFOLDER.length > 0) {

    stageConfig.EXTENSIONFRAME_BASELOCATION += "/" + stageConfig.EXTENSIONFRAME_BASEFOLDER;
}


var config = {
    "EXTENSIONFRAME_ENGINEV3_CSS" : stageConfig.EXTENSIONFRAME_BASELOCATION + "/extensionFrame/styles/engineV3.css",
    "EXTENSIONFRAME_BACKGROUND_HTML" : stageConfig.EXTENSIONFRAME_BASELOCATION + "/extensionFrame/background.html",
    "EXTENSIONFRAME_BACKGROUND_ANDROID_HTML" : stageConfig.EXTENSIONFRAME_BASELOCATION + "/extensionFrame/background.android.html",
    "TOPBAR_HTML" : stageConfig.EXTENSIONFRAME_BASELOCATION + "/dp-extension/TopBar/topbar.html",
    "TOPBAR_MOBILE_HTML" : stageConfig.EXTENSIONFRAME_BASELOCATION + "/dp-extension/TopBar/topbar.mobile.html",
    "TOPBAR_PRELOAD_HTML" : stageConfig.EXTENSIONFRAME_BASELOCATION + "/dp-extension/TopBar/topbar.preload.html",
    "TOPBAR_FORGET_PIN_LINK" : stageConfig.EXTENSIONFRAME_BASEURL + "/masterpassword/forget", // portal link, do not need base folder
    "TOPBAR_VIEW_DETAILS_LINK" : stageConfig.EXTENSIONFRAME_BASELOCATION + "/extensionPopOver/bho_index.html#passcard/__passcardId__/detail",
    "TOPBAR_LOGO_PATH" : "images/locales/__locale__/logo_lockup_header_topbar.png",
    "DEBUG_BASEURL" : stageConfig.EXTENSIONFRAME_BASELOCATION + "/debug" // for show in browser dev tool, should be the same as source map file def.
};

for (var key in stageConfig) {
    if (!stageConfig.hasOwnProperty(key)) continue;

    config[key] = stageConfig[key];
}

module.exports = config;